// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://gnosisscan.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://gnosisscan.io/address/0xe892E40C92c2E4D281Be59b2E6300F271d824E75
export const PROXY_ADMIN = '0xe892E40C92c2E4D281Be59b2E6300F271d824E75';

// https://gnosisscan.io/address/0x2cC41488f4494c5e11cB6cbA82199442B9f495B6
export const CREATE_3_FACTORY = '0x2cC41488f4494c5e11cB6cbA82199442B9f495B6';

// https://gnosisscan.io/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const PROTOCOL_GUARDIAN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// https://gnosisscan.io/address/0x0064AC007fF665CF8D0D3Af5E0AD1c26a3f853eA
export const wstETH_stETH_AGGREGATOR = '0x0064AC007fF665CF8D0D3Af5E0AD1c26a3f853eA';

// https://gnosisscan.io/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://gnosisscan.io/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://gnosisscan.io/address/0xdeadD8aB03075b7FBA81864202a2f59EE25B312b
export const MERIT_AHAB_SAFE = '0xdeadD8aB03075b7FBA81864202a2f59EE25B312b';

// https://gnosisscan.io/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://gnosisscan.io/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://gnosisscan.io/address/0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871
export const ALC_INCENTIVE_SAFE = '0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871';

// https://gnosisscan.io/address/0xAA870e4B82deaDa3727235f34183Ec9B728714C8
export const MERIT_INCENTIVE_SAFE = '0xAA870e4B82deaDa3727235f34183Ec9B728714C8';

// https://gnosisscan.io/address/0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e
export const AHAB_SAFE = '0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e';

// https://gnosisscan.io/address/0xE513b6304712D1055C88f72f1952FAe49c09f4ce
export const REWARD_STEWARD = '0xE513b6304712D1055C88f72f1952FAe49c09f4ce';

// https://gnosisscan.io/address/0x7520bb9c237c864957e9a9881821bF882491bc5C
export const AGENT_HUB = '0x7520bb9c237c864957e9a9881821bF882491bc5C';

// https://gnosisscan.io/address/0x5f65E68ddb5Cfdb5B64bD8562dBA08Af6b26818c
export const AGENT_HUB_AUTOMATION = '0x5f65E68ddb5Cfdb5B64bD8562dBA08Af6b26818c';

// https://gnosisscan.io/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 100;
